// extracted by mini-css-extract-plugin
export default {"sirTableBorderColor":"#dedede","table":"Table_table__BwMmx"};